import PropTypes from 'prop-types';
import React from 'react';
import {Box, LinearProgress, Typography} from '@mui/material';

const Wrapper = ({children}) => (
  <Box sx={{height: '100%', paddingY: 4}}>
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexGrow={1}
      height="100%"
      bgcolor="grey.100"
      borderRadius={1}
    >
      <Typography variant="h6" color="textSecondary">
        {children}
      </Typography>
    </Box>
  </Box>
);

Wrapper.propTypes = {
  children: PropTypes.node,
};

export const NoRowsOverlay = ({message = 'No Data'}) => {
  return <Wrapper>{message}</Wrapper>;
};

NoRowsOverlay.propTypes = {
  message: PropTypes.string,
};

export const NoResultsOverlay = ({message = 'No results found'}) => {
  return <Wrapper>{message}</Wrapper>;
};

NoResultsOverlay.propTypes = {
  message: PropTypes.string,
};

export const CustomLoadingOverlay = () => (
  <Box top={0} width="100%" height={5}>
    <LinearProgress
      sx={{
        height: 2,
        zIndex: 'speedDial',
        backgroundColor: 'grey.200',
      }}
      data-qe="grid-progress-bar"
    />
  </Box>
);
